import { combineReducers } from "redux";
import productHfData from "./productHfReducer";
import HeaderFooterData from "./headerReducer";
import pdpThirdPartyTemplateData from "./pdpThirdPartyReducer";
import contactUsPageData from "./contactUsPageReducer";
import partnerSearchContentPageData from "./partnerSearchContentReducer";
import partnerListData from "./partnerListReducer";

export default combineReducers({
  productHfData, HeaderFooterData,
  pdpThirdPartyTemplateData,
  contactUsPageData,
  partnerSearchContentPageData, partnerListData
});
